export enum NewPasswordFormItemName {
  NewPassword = "newPassword",
  AgainPassword = "againPassword",
}
